import React from "react";
import ModalToChange from "../../Layout/ModalToChange";
import { SelectForm } from "../../common/Buttons";
import TextInputModal from "../../common/TextInputModal";
import moment from "moment";
import { DatePicker } from "antd";

class DocumentAddModal extends React.Component {
  constructor() {
    super();
    this.state = {
      customer: "",
      email: "",
      phone: "",
      invoice_number: "",
      store_id: undefined,
      document_type_id: undefined,
      document_plan_id: undefined,
      price: 0,
      charge: 0,
      buy_date: moment(),
      filteredPlans: [],
      telNo: "",
    };
  }

  componentDidUpdate(_, prevState) {
    if (prevState.document_type_id !== this.state.document_type_id) {
      const Type = this.state.document_type_id;
      let filterPlan =
        Type === undefined
          ? []
          : this.props.documentPlan.filter((item) => item.type === Type);
      this.setState({
        filteredPlans: filterPlan,
      });
    }
    if (this.state.document_plan_id !== prevState.document_plan_id) {
      if (this.state.document_plan_id === undefined) {
        return;
      }
      const documentPlanId = this.props.documentPlan.findIndex(
        (item) => item.value == this.state.document_plan_id
      );

      if (documentPlanId !== -1) {
        this.setState({
          price: this.props.documentPlan[documentPlanId].cost,
          charge: this.props.documentPlan[documentPlanId].percentage,
        });
      }
    }
    if (this.state.store_id !== prevState.store_id) {
      this.setState({
        document_plan_id: undefined,
        document_type_id: undefined,
      });
    }
    if (this.state.document_type_id !== prevState.document_type_id) {
      this.setState({
        document_plan_id: undefined,
      });
    }
  }

  onSubmit = (e) => {
    e.preventDefault();
    const postVariables = {
      contract: {
        document_plan_id: this.state.document_plan_id,
        invoice_number: this.state.invoice_number.trim(),
        phone: this.state.phone,
        customer: this.state.customer,
        email: this.state.email,
        // warranty: this.state.warranty,
        price: this.state.price,
        charge: this.state.charge,
        buy_date: this.state.buy_date,
      },
    };
    // this.props.onSubmitContract(e, this.state.number, postVariables)

    this.props
      .addContractDocument(this.state.invoice_number, postVariables)
      .then((res) => {
        if (res) {
          this.setState({
            customer: "",
            email: "",
            phone: "",
            invoice_number: "",
            store_id: undefined,
            document_type_id: undefined,
            document_plan_id: undefined,
            price: 0,
            charge: 0,
            buy_date: moment(),
            filteredPlans: [],
          });
        }
      });
  };

  onChange = (e, select) => {
    if (select) {
      this.setState({
        [select]: e,
      });
    } else {
      this.setState({
        [e.target.name]: e.target.value,
      });
    }
  };

  inputOnFocus = () => {
    if (this.state.phone.length == 0) {
      this.setState({
        phone: "+3706",
      });
    }
  };

  render() {
    return (
      <ModalToChange
        handleSave={(e) => this.onSubmit(e)}
        status="tableEdit"
        text={"Create new"}
        buttonText={"Create"}
        // close={true}
      >
        <div className="text-bold my-1">
          Date <span className="orange_color">*</span>
        </div>
        <DatePicker
          style={{ width: "100%" }}
          placeholder="Data"
          disabledDate={(d) => d.isBefore(moment().subtract(40, "days"))}
          value={moment(this.state.buy_date) || ""}
          onChange={(e, arg) =>
            this.onChange(arg == "" ? moment() : arg, "buy_date")
          }
        />
        <TextInputModal
          required="true"
          text="Client"
          placeholder="Client"
          name="customer"
          value={this.state.customer}
          //   disabled={props.data.editable}
          onChange={(e) => this.onChange(e)}
        />
        <TextInputModal
          required="true"
          text="E.mail"
          placeholder="E.mail"
          name="email"
          value={this.state.email}
          //   disabled={props.data.editable}
          onChange={(e) => this.onChange(e)}
        />

        <TextInputModal
          required="true"
          text="Phone number"
          placeholder="Phone number"
          name="phone"
          style={
            this.state.phone.length === 12
              ? { border: "1px solid green" }
              : { border: "1px solid red" }
          }
          value={this.state.phone}
          onChange={(e) => this.onChange(e)}
          onFocus={() => this.inputOnFocus()}
          error={
            this.props.errors.phone &&
            this.props.errors.phone.map((item) => `${item} `)
          }
        />

        <TextInputModal
          required="true"
          text="Purchase document number"
          placeholder="Can be entered later"
          name="invoice_number"
          value={this.state.invoice_number}
          onChange={(e) => this.onChange(e)}
        />

        <div className="text-bold my-1">
          Store: <span className="orange_color">*</span>
        </div>
        <SelectForm
          onlyPlaceholder="Store"
          options={this.props.stores}
          value={this.state.store_id}
          onChange={(e) => this.onChange(e, "store_id")}
        />
        <div className="text-bold my-1">
          Type: <span className="orange_color">*</span>
        </div>
        <SelectForm
          onlyPlaceholder="Type"
          disabled={!this.state.store_id}
          options={this.props.documentType.filter(
            (e) => e.order_shop_id == this.state.store_id
          )}
          value={this.state.document_type_id}
          onChange={(e) => this.onChange(e, "document_type_id")}
        />

        <div
          className={`text-bold my-1 ${
            this.props.errors.document_plan_id ? "text-danger" : ""
          }`}
        >
          Plan: <span className="orange_color">*</span>
        </div>
        <SelectForm
          // mode="tags"
          onlyPlaceholder="Plan"
          options={this.state.filteredPlans}
          value={this.state.document_plan_id}
          onChange={(e) => this.onChange(e, "document_plan_id")}
          disabled={this.state.document_type_id === undefined}
          error={
            this.props.errors.document_plan_id &&
            this.props.errors.document_plan_id.map((item) => `${item} `)
          }
        />
        <TextInputModal
          required="true"
          type="number"
          text="Kaina"
          placeholder="Kaina"
          value={this.state.price}
          name="price"
          onChange={(e) => this.onChange(e)}
        />
        {/* 
        <div className="text-bold my-1">
          Gamintojo garantija:
          <span className="orange_color">*</span>
        </div> */}

        {/* <SelectForm
          onlyPlaceholder="Gamintojo garantija"
          options={warrantlyOption}
          value={this.state.warranty}
          onChange={(e) => this.onChange(e, "warranty")}
        /> */}
      </ModalToChange>
    );
  }
}
export default DocumentAddModal;
